import {
  Equal,
  objectEqual,
  optionalEqual,
  stringEqual,
} from "@redotech/util/equal";
import * as z from "zod/v4";

export enum ProductAsVariantCreationStrategyKind {
  TitleRegex = "titleRegex",
  MetafieldValue = "metafieldValue",
  MergeVariantOptions = "mergeVariantOptions",
}

export const productAsVariantStrategyEqual: Equal<ProductAsVariantStrategy> =
  objectEqual<ProductAsVariantStrategy>({
    strategy: stringEqual,
    category: stringEqual,
    regex: optionalEqual(stringEqual),
    metafield: optionalEqual(
      objectEqual<{ namespace: string; key: string }>({
        namespace: stringEqual,
        key: stringEqual,
      }),
    ),
  });

export const ProductAsVariantTitleRegexStrategySchema = z.object({
  strategy: z.literal(ProductAsVariantCreationStrategyKind.TitleRegex),
  regex: z.string(),
  category: z.string(),
});
export type ProductAsVariantTitleRegexStrategy = z.infer<
  typeof ProductAsVariantTitleRegexStrategySchema
>;

export const ProductAsVariantMetafieldValueStrategySchema = z.object({
  strategy: z.literal(ProductAsVariantCreationStrategyKind.MetafieldValue),
  metafield: z.object({ namespace: z.string(), key: z.string() }),
  regex: z.string().optional(),
  category: z.string(),
});
export type ProductAsVariantMetafieldValueStrategy = z.infer<
  typeof ProductAsVariantMetafieldValueStrategySchema
>;

export const ProductAsVariantMergeVariantOptionsStrategySchema = z.object({
  strategy: z.literal(ProductAsVariantCreationStrategyKind.MergeVariantOptions),
  category: z.string(),
});
export type ProductAsVariantMergeVariantOptionsStrategy = z.infer<
  typeof ProductAsVariantMergeVariantOptionsStrategySchema
>;

export const ProductAsVariantStrategySchema = z.discriminatedUnion("strategy", [
  ProductAsVariantTitleRegexStrategySchema,
  ProductAsVariantMetafieldValueStrategySchema,
  ProductAsVariantMergeVariantOptionsStrategySchema,
]);

export type ProductAsVariantStrategy = z.infer<
  typeof ProductAsVariantStrategySchema
>;
